import Glide from "@glidejs/glide";

const blogCardSliderHandler = () => {
	const blogSliders = document.querySelectorAll(".blog-card-row__glide");

	blogSliders.forEach((slider, i) => {
		const autoplay = slider.dataset.autoplay;
		// Check if the slider has already been initialized
		if (!slider.hasAttribute("data-initialized")) {
			new Glide(slider, {
				type: "carousel",
				startAt: 0,
				perView: 1,
				autoplay: Number(autoplay),
				gap: 10,
			}).mount();
			// Mark the slider as initialized
			slider.setAttribute("data-initialized", "true");
		}
	});

	const blogDesktopSliders = document.querySelectorAll(
		".blog-card-row__glide--desktop",
	);

	if (blogDesktopSliders.length) {
		blogDesktopSliders.forEach((slider, i) => {
			const gap = slider.dataset.gap;
			const autoplay = slider.dataset.autoplay;
			// Check if the slider has already been initialized
			if (!slider.hasAttribute("data-initialized")) {
				new Glide(slider, {
					type: "carousel",
					startAt: 0,
					perView: 3,
					autoplay: Number(autoplay),
					gap: Number(gap),
					breakpoints: {
						1024: { perView: 2 },
					},
				}).mount();

				// Mark the slider as initialized
				slider.setAttribute("data-initialized", "true");
			}
		});
	}
};

if (document.readyState !== "loading") {
	blogCardSliderHandler();
} else {
	document.addEventListener("DOMContentLoaded", blogCardSliderHandler);
}